<div class="buttons-list-container">
  <app-loader *ngIf="!configurationData; else buttonsContainer"></app-loader>
  <ng-template #buttonsContainer>
    <div #buttonList class="buttons-list" (scroll)="checkIfScrolled()" id="allButtons">
      <div class="inner-container">
        <div class="single-banner" *ngFor="let button of configurationData" (click)="getValue(button)">
          <img class="button-image" [src]=" button.image" />
        </div>
      </div>
      <div class="modal-inner-container-mask" *ngIf="!scrolledToBottom"></div>
    </div>
  </ng-template>
</div>
